import { render, staticRenderFns } from "./CustomerSearch.vue?vue&type=template&id=88f5cd34&"
import script from "./CustomerSearch.vue?vue&type=script&lang=ts&"
export * from "./CustomerSearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports